const scopeThreePreviewRegistry = {};

function resolve(key) {
  if (!scopeThreePreviewRegistry[key]) {
    throw new Error(`Trying to get invalid category with key: ${key}`);
  }
  return scopeThreePreviewRegistry[key];
}

function register(key, Component) {
  scopeThreePreviewRegistry[key] = Component;
}

const registry = { resolve, register };

export default registry;
